// extracted by mini-css-extract-plugin
export default {"category":"styles_category__M1Mi4","selectedCategory":"styles_selectedCategory__nuJAb"};